import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { SelectModalComponent } from '@modals/select-modal/select-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectModalData, ErrorInt, OptsErrorModal } from '@interfaces/*';
import { CodesErrorJSON, TypesErrors } from '@app/enums/errors.enum';
import { format, prepPectabDynamicContent, getTextError } from '@utils/formats/printFormat';
import { TranslateService } from '@ngx-translate/core';
import { ErrorsModalComponent } from '@app/shared/modals/errors/errors-modal/errors-modal.component';
import { ErrorsModalDestinationComponent } from '@app/shared/modals/errors/errors-modal-destination/errors-modal-destination.component';
import { ATBPrinterDeviceService, PrintErrorGuardService } from './devices';
import { errors } from '@utils/constants/errors';
import { Passenger as PassengerOld, Reservation as ReservationOld } from '@app/models';
import { Passenger, Reservation } from '@app/models/micro';
import { ErrorGA4Int } from '@app/interfaces/ga4.interface';
import { UrlService } from './url.service';
import { Ga4Service } from './ga4.service';
import { ErrorsModalCknComponent } from '@modals/errors/errors-modal-ckn/errors-modal-ckn.component';
import { AmKeyboardService } from '@app/shared/components/am-keyboard/am-keyboard.service';
import { GlobalsService } from '@services/micro/globals.service';
import { ErrorModel } from '@models/micro/error.model';
import { AirLinesComponent } from '@modals/air-lines/air-lines.component';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ExperiencePollModalComponent } from '@modals/experience-poll-modal/experience-poll-modal.component';
@Injectable({
  providedIn: 'root',
})
export class MessagesService {
  private modalRef = null;
  subscribeReference: Subscription;
  opts = {
    width: 570,
    showConfirmButton: true,
    confirmButtonText: 'OK',
    focusConfirm: true,
    customClass: {
      container: 'am-alert-container',
      actions: 'am-alert-footer',
      content: 'am-alert-content',
      confirmButton: 'am-alert-button am-alert-button-confirm',
      cancelButton: 'am-alert-button am-alert-button-cancel',
      header: 'am-alert-header',
      popup: 'am-alert-popup',
    },
  };

  constructor(
    private modalService: NgbModal,
    private _translateService: TranslateService,
    private ATBPrinter: ATBPrinterDeviceService,
    private _printErrorGuard: PrintErrorGuardService,
    private _urlService: UrlService,
    private _ga4Service: Ga4Service,
    private _keyboard: AmKeyboardService,
    private _globals: GlobalsService,
    private _router: Router
  ) {}

  errorMessageDestination(
    message: {
      error?: ErrorModel;
    },
    subFunnelName?
  ) {
    const { error } = message;
    const modalRef = this.modalService.open(ErrorsModalDestinationComponent, {
      fullscreen: true,
      centered: true,
      keyboard: false,
      backdrop: false,
    });

    const code = error.getCode();
    modalRef.componentInstance.codeError = code;
    const messageError = this._translateService.instant('errors.pnrLookup.reservationNoFound.text');
    this.sendEventErrorGa4(messageError, code, error, subFunnelName);
  }

  errorNoCkin(
    message: {
      typesError?: TypesErrors;
      error?: ErrorInt;
    },
    code: string,
    subject: TypesErrors | CodesErrorJSON | string,
    opts: OptsErrorModal,
    subFunnelName?: string,
    showListPassengers?: boolean
  ) {
    const msg = message.error?.error?.msg || message.error?.msg;
    const uuid = (message && message.error?.error?.uuid) || (message && message.error?.uuid);
    this._keyboard.destroy();
    return this.showErrorNoCknMessage(
      { code, uuid, subject, msg, opts },
      message.error,
      subFunnelName,
      showListPassengers
    );
  }

  showErrorNoCknMessage(
    params: {
      code: string;
      uuid: string;
      subject: TypesErrors | CodesErrorJSON | string;
      msg;
      opts: OptsErrorModal;
    },
    error,
    subFunnelName?,
    showListPassengers?
  ) {
    this.closeAll();
    const { code, uuid, subject, msg = '', opts } = params;
    let titleError = '' as any;
    let messageError = '' as any;
    let messageErrorGa4 = '' as any;
    if (subject == CodesErrorJSON.ERROR_FROM_JSON) {
      const currentLanguage = this._translateService.currentLang.replace('-', '_');
      const arrayCode = code && errors.filter((x) => x.code == code);
      titleError = arrayCode && arrayCode[0][currentLanguage].title;
      messageErrorGa4 = messageError = arrayCode && arrayCode[0][currentLanguage].message;
    } else if (subject === '' || subject === null) {
      titleError = 'errorMsj.generic_header';
      messageErrorGa4 = messageError = msg;
    } else if (getTextError(subject) !== '') {
      titleError = getTextError(subject).title;
      messageError = getTextError(subject).text;
      messageErrorGa4 = this._translateService.instant(messageError as string);
    } else {
      titleError = this._translateService.instant((subject || 'errorMsj.msj.title') as string);
      messageErrorGa4 = messageError = msg;
    }

    const modalRef = this.modalService.open(ErrorsModalCknComponent, {
      fullscreen: true,
      centered: true,
      keyboard: false,
      backdrop: false,
    });
    modalRef.componentInstance.titleError = titleError;
    modalRef.componentInstance.msgError = messageError;
    modalRef.componentInstance.printCard = '';
    modalRef.componentInstance.codeError = code;
    modalRef.componentInstance.uuidError = uuid;
    modalRef.componentInstance.backgroundColorModal = opts.backgroundColorModal || 'am-light';
    modalRef.componentInstance.showButton = opts.showButton ?? true;
    modalRef.componentInstance.buttonCopy = opts.buttonCopy || 'errorMsj.msj.button';
    modalRef.componentInstance.showIconImage = opts.showIconImage || false;
    modalRef.componentInstance.urlIconImage = opts.urlIconImage;
    modalRef.componentInstance.colorFontButton = opts.colorFontButton || 'blue-font';
    modalRef.componentInstance.backGroundButton = opts.backGroundButton || 'search-bg';
    modalRef.componentInstance.sizeModal = opts.sizeModal;
    modalRef.componentInstance.fontWeightTitleError = opts.fontWeightTitleError || '500';
    modalRef.componentInstance.image = opts.image || null;
    modalRef.componentInstance.showCancelButton = opts.showCancelButton || false;
    modalRef.componentInstance.cancelButtonText = opts.cancelButtonText || 'errorMsj.cancel';
    modalRef.componentInstance.showListPassengers = showListPassengers;
    this.modalRef = modalRef;
    this.sendEventErrorGa4(messageErrorGa4, code, error, subFunnelName);

    return modalRef.result;
  }

  errorMessage(
    message: { title?: string; text?: string; typesError?: TypesErrors },
    callback: any = () => {}
  ) {
    if (message.typesError) {
      Object.assign(message, this.getError(message.typesError));
    }
    const { title, text } = message;
    Swal.fire({
      title,
      text,
      imageUrl: '../../assets/images/alert/warning.svg',
      imageWidth: 92,
      ...this.opts,
    })
      .then(() => {
        callback();
      })
      .catch((error) => {});
  }

  error(
    message: {
      typesError?: TypesErrors;
      error?: ErrorModel;
    },
    code: string,
    subject: TypesErrors | CodesErrorJSON | string,
    opts: OptsErrorModal,
    subFunnelName?: string,
    printError?: boolean
  ) {
    const { error } = message;
    const msg = error?.getMessage?.() || subject;
    const uuid = '';
    return this.showErrorMessage(
      { code, uuid, subject, msg, opts },
      message.error,
      subFunnelName,
      printError
    );
  }

  showErrorMessage(
    params: {
      code: string;
      uuid: string;
      subject: TypesErrors | CodesErrorJSON | string;
      msg;
      opts: OptsErrorModal;
    },
    error,
    subFunnelName?,
    printError?
  ) {
    this.closeAll();
    const { code, uuid, subject, msg = '', opts } = params;
    let titleError = '' as any;
    let messageError = '' as any;
    let messageErrorGa4 = '' as any;
    const reservation = this._globals.getReservation();
    if (subject === CodesErrorJSON.ERROR_FROM_JSON) {
      const currentLanguage = this._translateService.currentLang.replace('-', '_');
      const arrayCode = code && errors.filter((x) => x.code === code);
      titleError = arrayCode && arrayCode[0][currentLanguage].title;
      messageErrorGa4 = messageError = arrayCode && arrayCode[0][currentLanguage].message;
    } else if (subject === '' || subject === null) {
      titleError = 'errorMsj.generic_header';
      messageErrorGa4 = messageError = msg;
    } else if (getTextError(subject) !== '') {
      titleError = getTextError(subject).title;
      messageError = getTextError(subject).text;
      messageErrorGa4 = this._translateService.instant(messageError as string);
    } else {
      titleError = this._translateService.instant((subject || 'errorMsj.msj.title') as string);
      messageErrorGa4 = messageError = msg;
    }

    const modalRef = this.modalService.open(ErrorsModalComponent, {
      fullscreen: true,
      centered: true,
      keyboard: false,
      backdrop: false,
    });
    modalRef.componentInstance.titleError = titleError;
    modalRef.componentInstance.msgError = messageError;
    modalRef.componentInstance.printCard = '';
    modalRef.componentInstance.codeError = code;
    modalRef.componentInstance.uuidError = uuid;
    modalRef.componentInstance.backgroundColorModal = opts.backgroundColorModal || 'am-light';
    modalRef.componentInstance.showButton = opts.showButton ?? true;
    modalRef.componentInstance.buttonCopy = opts.buttonCopy || 'errorMsj.msj.button';
    modalRef.componentInstance.showIconImage = opts.showIconImage || false;
    modalRef.componentInstance.urlIconImage = opts.urlIconImage;
    modalRef.componentInstance.colorFontButton = opts.colorFontButton || 'blue-font';
    modalRef.componentInstance.backGroundButton = opts.backGroundButton || 'search-bg';
    modalRef.componentInstance.sizeModal = opts.sizeModal;
    modalRef.componentInstance.fontWeightTitleError = opts.fontWeightTitleError || '500';
    modalRef.componentInstance.image = opts.image || null;
    modalRef.componentInstance.showCancelButton = opts.showCancelButton || false;
    modalRef.componentInstance.cancelButtonText = opts.cancelButtonText || 'errorMsj.cancel';
    modalRef.componentInstance.showClose = opts?.showClose ?? true;
    modalRef.componentInstance.shortPadding = opts?.shortPadding ?? false;
    this.modalRef = modalRef;
    this.sendEventErrorGa4(messageErrorGa4, code, error, subFunnelName);

    if (!printError) {
      this.printErrorCard(
        error?.getCodeNumber?.() ?? 99,
        error,
        reservation?.pnr,
        reservation,
        null,
        msg
      );
    }

    return modalRef.result;
  }
  // Keep the implementation as is
  printErrorCard(
    id: number,
    error: ErrorModel | any,
    pnr: string = '',
    reservation: ReservationOld | Reservation | null = null,
    passengersSelection: Array<PassengerOld | Passenger> | null = null,
    msg: string = ''
  ) {
    const errorId = id || error?.code || error?.getCodeNumber?.() || 'no-id';
    const errorPnr = pnr || reservation?.pnr || 'no-pnr';
    const errorMsg = msg || error?.message || error?.getMessage?.() || 'no-msg';
    const errorKey = `${errorId}-${errorPnr}-${errorMsg}`;

    if (!this._printErrorGuard.canPrint(errorKey)) {
      return;
    }

    this._printErrorGuard.markAsPrinted(errorKey);

    const currentLanguage = this._translateService.currentLang.replace('-', '_');
    const formatPrinter = format;
    const content = prepPectabDynamicContent(
      id,
      error,
      pnr,
      reservation?.flightSummary,
      passengersSelection,
      currentLanguage,
      msg
    );
    this.ATBPrinter.load(formatPrinter);
    setTimeout(() => this.ATBPrinter.print(content), 800);
  }

  infoMessage(title: string, text: string, callback: any = () => {}) {
    Swal.fire({
      title,
      text,
      imageUrl: '../../assets/images/alert/warning.svg',
      imageWidth: 92,
      ...this.opts,
    })
      .then(() => {
        callback();
      })
      .catch((error) => {});
  }

  showListSelect(options: SelectModalData): Promise<any> {
    const { title, subtitle, notice, list } = options;
    const modalRef = this.modalService.open(SelectModalComponent, {
      fullscreen: true,
      centered: true,
      keyboard: false,
      backdrop: true,
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.subtitle = subtitle;
    modalRef.componentInstance.notice = notice;
    modalRef.componentInstance.list = list;
    return modalRef.result;
  }

  closeError() {
    this.modalService.dismissAll();
  }

  getError(error: TypesErrors) {
    let title,
      text = '';
    switch (error) {
      case TypesErrors.GENERIC_ERROR:
      case TypesErrors.PAYMENT_ERROR_RETRY:
      case TypesErrors.PAYMENT_ERROR_COUNTER:
      case TypesErrors.UNACCOMPANIED_MINOR:
      case TypesErrors.CREDIT_CARD_READ_ERROR:
      case TypesErrors.PASSPORT_SCAN_ERROR:
      case TypesErrors.RESERVATION_NOT_FOUND:
        title = this._translateService.instant('errors.pnrLookup.reservationNoFound.title');
        text = this._translateService.instant('errors.pnrLookup.reservationNoFound.text');
        break;
      case TypesErrors.FARELOCK_ERROR:
        title = this._translateService.instant('errors.pnrLookup.farelockReservation.title');
        text = this._translateService.instant('errors.pnrLookup.farelockReservation.text');
        break;
      case TypesErrors.RESERVATION_PNR_NOT_FOUND:
        title = this._translateService.instant('errors.pnrLookup.reservationPnrNotFound.title');
        text = this._translateService.instant('errors.pnrLookup.reservationPnrNotFound.text');
        break;
      case TypesErrors.UNABLE_TO_REMOVE_ITEM:
      case TypesErrors.TOO_LATE_FOR_CHECKIN:
      case TypesErrors.TOO_EARLY_FOR_CHECKIN:
      case TypesErrors.FLIGHT_NOT_OPERATED_BY_AM:
      case TypesErrors.CREDIT_CARD_DECLINED:
      case TypesErrors.CREDIT_CARD_HOST_ERROR:
      case TypesErrors.CHECKIN_ERROR:
      case TypesErrors.CHECKIN_OVI_ERROR:
      case TypesErrors.CHECKIN_OVS_ERROR:
      case TypesErrors.CHECKIN_ABOVE_AUTHORIZATION_ERROR:
      case TypesErrors.LOAD_BALANCER:
      case TypesErrors.TIMEOUT_ERROR:
      case TypesErrors.SCAN_PASSPORT_ERROR:
      case TypesErrors.PINPAD_NOT_READY_ERROR:
      case TypesErrors.TSA_VALIDATION:
      case TypesErrors.PNR_LOOKUP_FAILURE:
      case TypesErrors.PAID_SEAT_AT_COUNTER:
      case TypesErrors.NO_ELIGIBLE_PASSENGERS:
      case TypesErrors.STATIC_PROFILE_UPDATE:
      case TypesErrors.PROFILE_UPDATE:
      case TypesErrors.PP_SCAN_FAIL:
      case TypesErrors.DEST_SEARCH_FAIL:
      case TypesErrors.FLIGHT_SEARCH_FAIL:
      case TypesErrors.PINPAD_INIT_FAIL:
      case TypesErrors.MANUALLY_ENTERED_CARD_ERROR:
      case TypesErrors.EMAIL_ERROR:
      case TypesErrors.REPRINT_BOARDING_PASSES_ERROR:
      case TypesErrors.FAILED_TO_RESERVE_PREMIERE_UPGRADE:
      case TypesErrors.OVERWEIGHT_BAG_CHECKIN_ERROR:
      case TypesErrors.ALL_SEATS_SELECTED:
      case TypesErrors.PAYMENT_NOT_SUPPORTED:
      case TypesErrors.CART_UPDATE_FAILED:
      case TypesErrors.BAGGAGE_OVERWEIGHT_ERROR:
      case TypesErrors.AGENT_SCAN_FAILED:
      case TypesErrors.FREQUENT_FLIER_ERROR:
      case TypesErrors.START_OVER_AUTH_REQUIRED:
      case TypesErrors.START_OVER_AUTH_REQUIRED_CANCELLED:
      case TypesErrors.BAG_TAG_ERROR:
      case TypesErrors.BAG_TAG_RETRY_WARNING:
      case TypesErrors.OVER_BOOKING_UPDATE_ERROR:
      case TypesErrors.OVERBOOKING_CONFIRMATION:
      case TypesErrors.WARNING_CONECCTION_BAGGAGE:
      case TypesErrors.PREMIER_TYPE_WITHOUT_BAGGAGE:
      case TypesErrors.PREMIER_TYPE_WITH_BAGGAGE:
      case TypesErrors.PREMIER_TYPE_ADD:
    }
    return {
      title,
      text,
    };
  }

  closeAll() {
    if (this.modalRef) {
      this.modalRef?.close();
    }
    if (Swal) {
      Swal.close();
    }
  }

  sendEventErrorGa4(messageError, code, dataError, subFunnelName?) {
    let actionableValue = '';

    if (Array.isArray(dataError?.actionable) && dataError.actionable.length > 0) {
      actionableValue = `${dataError?.actionable[0].toUpperCase()}${dataError?.actionable
        .substring(1)
        .toLowerCase()}`;
    } else {
      actionableValue = 'ERROR';
    }

    let error = dataError?.error;

    if (!error) {
      error = {
        _meta: dataError?._meta,
        actionable: actionableValue,
        msg: dataError?.msg,
      };
    }

    const errorGA4Int: ErrorGA4Int = {
      error_message: messageError,
      error_type: error._meta?.class,
      error_category: error?.actionable ?? dataError?.status === 500 ? 'ABORT' : 'FIX',
      error_code: code ?? error?.code,
      error_desc: error.msg,
      error_source: 'Kiosk',
      error_url: this._urlService.currentUrl,
      statusCode: error?.actionable ?? dataError?.status === 500 ? '500' : '400',
      sub_funnel_name: subFunnelName ?? this._urlService.subFunnelName,
      session_id_kos:
        this._ga4Service?.nameSession ||
        this._ga4Service.getSessionIdKos(subFunnelName ?? this._urlService.subFunnelName),
    };

    this._ga4Service.sendErrorEvent(errorGA4Int);
  }

  openCodeInfoModal(operatingCarrier: string, error: ErrorModel): void {
    const reservation = this._globals.getReservation();
    const modalRef = this.modalService.open(AirLinesComponent, {
      centered: true,
      size: 'xl',
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.componentInstance.operatingCarrier = operatingCarrier;

    this.subscribeReference = modalRef.closed.subscribe(
      (resp) => {
        if (error) {
          this.printErrorCard(
            error.getCodeNumber(),
            error,
            reservation.pnr,
            reservation,
            null,
            error.getMessage()
          );
        }
        this._router.navigate(['/home']);
      },
      (error: ErrorInt) => {},
      () => {}
    );
  }

  showOverBagsLimit() {
    this.error({}, '', TypesErrors.LIMIT_BAGS, {
      showButton: true,
      buttonCopy: 'accept',
      showIconImage: false,
      colorFontButton: 'white-font',
      backGroundButton: 'search-bg',
      sizeModal: 'lg',
      fontWeightTitleError: '600',
      image: '../../../../../assets/images/bags/limitBags.svg',
    }).finally(() => {
      this._router.navigate(['/']);
    });
  }

  /*
  openCodeInfoModal(operatingCarrier): void {
    const modalRef = this.modalService.open(AirLinesComponent,
      {
        centered: true,
        size: 'xl',
        backdrop: 'static',
        keyboard: false
      });

    modalRef.componentInstance.operatingCarrier = operatingCarrier;

    this.subscribeReference = modalRef.closed.subscribe(resp => {
      this._router.navigate(['/home']);

    },
      (error: ErrorInt) => {

      }, () => {
      })
  }*/

  /**
   * Abre el modal de encuesta de experiencia SSBD.
   * Se cierra automáticamente en 10 segundos con valor "excellent" si el usuario no responde.
   */
  openPoll(): void {
    this.modalService.open(ExperiencePollModalComponent, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'experience-poll-modal-window',
    });
  }
}
